"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldCodeParserPage = void 0;
var tslib_1 = require("tslib");
var layout_position_creator_1 = require("../../../layout-engine/layout-position-creator");
var document_layout_details_level_1 = require("../../../layout/document-layout-details-level");
var names_1 = require("../names");
var field_code_parser_client_updating_base_1 = require("./field-code-parser-client-updating-base");
var FieldCodeParserPage = (function (_super) {
    tslib_1.__extends(FieldCodeParserPage, _super);
    function FieldCodeParserPage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(FieldCodeParserPage.prototype, "name", {
        get: function () { return names_1.FieldName.Page; },
        enumerable: false,
        configurable: true
    });
    FieldCodeParserPage.prototype.fillResult = function () {
        var pos = this.getPosition();
        if (pos == null)
            return true;
        this.setInputPositionState();
        if (this.subDocument.isMain()) {
            var layoutPosition = layout_position_creator_1.LayoutPositionMainSubDocumentCreator.ensureLayoutPosition(this.layoutFormatterManager, this.subDocument, pos, document_layout_details_level_1.DocumentLayoutDetailsLevel.Page, new layout_position_creator_1.LayoutPositionCreatorConflictFlags().setDefault(false), new layout_position_creator_1.LayoutPositionCreatorConflictFlags().setDefault(true));
            var pageText = this.getFormattedResult(layoutPosition.pageIndex + 1);
            this.replaceTextByInterval(this.getTopField().getResultInterval(), pageText);
        }
        else
            this.replaceTextByLayoutDependentRun(this.getTopField().getResultInterval());
        return true;
    };
    FieldCodeParserPage.prototype.getPosition = function () {
        var field = this.getTopField();
        return field.showCode ? field.getCodeStartPosition() : field.getResultStartPosition();
    };
    return FieldCodeParserPage;
}(field_code_parser_client_updating_base_1.FieldCodeParserClientUpdatingBase));
exports.FieldCodeParserPage = FieldCodeParserPage;
